import { render } from "./SobreNosComponent.vue?vue&type=template&id=d67908fc&scoped=true"
import script from "./SobreNosComponent.vue?vue&type=script&lang=js"
export * from "./SobreNosComponent.vue?vue&type=script&lang=js"

import "./SobreNosComponent.vue?vue&type=style&index=0&id=d67908fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67908fc"]])

export default __exports__